import { NgModule } from '@angular/core';
import { AdminSenderPage, SenderEmailModalContent, SenderSmsModalContent } from './admin-sender.page';
import { SharedModule } from 'app/shared.module';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [AdminSenderPage, SenderEmailModalContent, SenderSmsModalContent],
  exports: [AdminSenderPage]
})
export class AdminSenderPageModule {}
